import { PhaseTag } from './PhaseTag';

export type OnlineDividerProps = {
  label: string;
};

/** Hairline divider with a centred eyebrow chip — splits the CTA stack. */
export const OnlineDivider = ({ label }: OnlineDividerProps) => (
  <div className="my-1 flex items-center gap-3">
    <span className="h-px flex-1 bg-ink/20" />
    <PhaseTag size={9} tracking={0.22} color="var(--color-ink-soft)">
      {label}
    </PhaseTag>
    <span className="h-px flex-1 bg-ink/20" />
  </div>
);
